import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import AppBar from "@mui/material/AppBar";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Banner from "./components/Banner";
import Incubation from "./components/Incubation";
import Ideas from "./components/Ideas";

const InnovationHub = () => {
  return (
    <Box>
      <Helmet>
        <title> Innovation Hub | Oluseun Onigbinde Resource Centre</title>
      </Helmet>

      <AppBar
        position={"sticky"}
        elevation={0}
        padding={"5px 0px"}
        sx={{
          backgroundColor: "#F6F5F5",
        }}
      >
        <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
          <Header />
        </Container>
      </AppBar>
      <Box bgcolor={"#050C4C"}>
        <Banner />
      </Box>
      <Box bgcolor={"#050C4C"}>
        <Container>
          <Incubation />
        </Container>
      </Box>
      <Box bgcolor={"#F6F5F5"}>
        <Container>
          <Ideas />
        </Container>
      </Box>
      <Box bgcolor={"#F6F5F5"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default InnovationHub;
